import { eachDayOfInterval, parseISO } from 'date-fns';

import { CalendarCreationTimeslotInterface } from '~/organizer/shared/components/shared/calendar/interfaces/recurrent-event.interface';

export function getAllDatesFromCreationTimeslot(
  creationTimeslot: CalendarCreationTimeslotInterface
): Date[] {
  if (
    !creationTimeslot.isRecurrent ||
    !creationTimeslot.daysOfWeek?.length ||
    !creationTimeslot.endDate
  ) {
    return [parseISO(new Date(creationTimeslot.startDate).toISOString())];
  }

  return eachDayOfInterval({
    start: new Date(creationTimeslot.startDate),
    end: new Date(creationTimeslot.endDate),
  }).filter((date) => creationTimeslot.daysOfWeek.includes(date.getDay()));
}
